<template>
  <tr :style="sticky ? 'position: sticky;top: 0; background-color: #fff; z-index:2' : ''" @contextmenu.prevent>
    <th v-if="header.show" :class="`pr-1 ${header.class ? header.class : 'text-start'}`" style="border-bottom: 1px solid grey; width:1%; max-width: 260px !important" v-for="(header, index) in valuedHeaders" :key="index" @contextmenu.prevent>
      <span v-if="!header.queryable">{{header.text}}</span>
      <v-text-field
          v-else-if="header.queryable.type === 'text'"
          v-model="header.queryable.value"
          :label="header.text"
          dense
          outlined
          clearable
          @keyup.enter="query"
      >
        <template v-if="header.queryable.value && header.queryable.value.length > 0" v-slot:append-outer>
          <v-tooltip bottom>
            <template v-slot:activator="{on}">
              <v-btn v-on="on" @click="query" color="green" x-small :loading="loading" :disabled="loading">go</v-btn>
            </template>
            <span>Run query</span>
          </v-tooltip>
        </template>
      </v-text-field>
      <v-autocomplete
          v-else-if="header.queryable.type === 'multi-select'"
          v-model="header.queryable.value"
          :label="header.text"
          :items="items[header.queryable.model] ? items[header.queryable.model] : items.placeHolder"
          return-object
          item-text="name"
          @focusin="setItems(header.queryable.model)"
          dense
          outlined
          clearable
          multiple
          @keyup.enter="query"
      >
<!--        <template v-if="header.queryable.aka" v-slot:item="{item}">-->
<!--          <v-list-item-content>-->
<!--            <v-list-item-title>{{item.name}}</v-list-item-title>-->
<!--            <v-tooltip bottom>-->
<!--              <template v-slot:activator="{on}">-->
<!--                <v-list-item-subtitle>{{loadAka(header.queryable.aka, item)}}</v-list-item-subtitle>-->
<!--              </template>-->
<!--              <span>{{}}</span>-->
<!--            </v-tooltip>-->

<!--          </v-list-item-content>-->
<!--        </template>-->
        <template v-if="header.queryable.value && header.queryable.value.length > 0" v-slot:append-outer>
          <v-tooltip bottom>
            <template v-slot:activator="{on}">
              <v-btn v-on="on" @click="query" color="green" x-small :loading="loading" :disabled="loading">go</v-btn>
            </template>
            <span>Run query</span>
          </v-tooltip>
        </template>
        <template v-if="header.queryable.model === 'sampleTestTypes' && header.queryable.scoped_param_queries" v-slot:prepend-item>
          <v-btn-toggle v-model="header.queryable.scoped_param_queries" multiple>
            <v-tooltip bottom>
              <template v-slot:activator="{on}">
                <v-btn v-on="on" value="awaitingPrep">
                  <v-chip class="error white--text" x-small></v-chip>
                </v-btn>
              </template>
              <span>Samples Awaiting Prep</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{on}">
                <v-btn v-on="on" value="qaRetest">
                  <v-chip class="purple white--text" x-small></v-chip>
                </v-btn>
              </template>
              <span>Samples With Retests and no analytes</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{on}">
                <v-btn v-on="on" value="testComplete">
                  <v-chip class="blue white--text" x-small></v-chip>
                </v-btn>
              </template>
              <span>Samples With Completed Tests</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{on}">
                <v-btn v-on="on" value="qaAbleTest">
                  <v-chip class="success white--text" x-small></v-chip>
                </v-btn>
              </template>
              <span>Samples With tests waiting for QA</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{on}">
                <v-btn v-on="on" value="testWeighed">
                  <v-chip class="amber black--text" x-small></v-chip>
                </v-btn>
              </template>
              <span>Samples with tests that are weighed(prepped)</span>
            </v-tooltip>
          </v-btn-toggle>
        </template>
      </v-autocomplete>
      <v-btn-toggle
          v-else-if="header.queryable.type === 'toggle'"
          v-model="header.queryable.value"
          multiple
          dense
          active-class="error"
          class="mb-5"
      >
        <v-btn v-for="item in $store.$db().model(header.queryable.model).all()" :value="item.uuid" :key="item.uuid" small>{{item.name}}</v-btn>
      </v-btn-toggle>
      <v-checkbox
          v-else-if="header.queryable.type === 'boolean'"
          v-model="header.queryable.value"
          :label="header.text"
          @mouseup.right="header.queryable.value = null"
          :true-value="true"
          :false-value="false"
          :indeterminate="header.queryable.value === null"
      >
        <template v-if="header.queryable.value !== null" v-slot:append>
          <v-tooltip bottom>
            <template v-slot:activator="{on}">
              <v-btn v-on="on" @click="query" color="green" x-small :loading="loading" :disabled="loading">go</v-btn>
            </template>
            <span>Run query</span>
          </v-tooltip>
        </template>
      </v-checkbox>
    </th>
  </tr>
</template>

<script>
export default {
  name: "SampleTrackingTableHeader",
  components: {},
  data: () => ({
    valuedHeaders: [],
    items: {
      placeHolder: [],
    },
  }),
  props:{
    headers:{
      required: true,
    },
    loading: {
      type: Boolean,
      default: false
    },
    sticky: {
      type: Boolean,
      default: false,
    }
  },
  watch:{
    headers(v){
      console.log('called')
      this.valuedHeaders = [...v];
    }
  },
  mounted(){
    this.valuedHeaders = [...this.headers];
  },
  methods: {
    loadAka(aka, current){
      if(aka.filter){
        return this.$store.$db().model(aka.model).query().where(v => v[aka.key] === current[aka.key] && v[aka.text] !== current[aka.text]).get()
            // .reduce((arr, v) => (arr.push(v[aka.text])),[]).join(', ')
      }
      return this.$store.$db().model(aka.model).where(v => v[aka.key] === current[aka.key]).get()
          // .reduce((arr, v) => (arr.push(v[aka.text])),[]).join(', ')
    },
    query(){
      let query = this.generateWhereQuery();
      const scopedQueries = this.generateScopedParamQueries();
      if(scopedQueries){
        query = {
          ...query,
          scoped_param_queries: scopedQueries,
        }
      }
      console.log(query, 'query');
      if(query.where || query.where_in || query.where_has){
        this.$emit('query', query)
      }
    },
    setItems(model){
      if(!this.items[model]){
        this.$set(this.items, model, this.$store.$db().model(model).all())
        // this.items[model] = this.$store.$db().model(model).all();
      }
    },
    generateScopedParamQueries(){
      const headers = this.valuedHeaders.filter(header => header.queryable);
      const tests = headers.find(header => header.queryable && header.queryable.relation === "sampleTests");
      if(tests && tests.queryable.scoped_param_queries && tests.queryable.scoped_param_queries.length > 0 && tests.queryable.value.length > 0){
        return tests.queryable.scoped_param_queries.reduce((arr, scope) => {
          for(let type of tests.queryable.value){
            arr.push([scope, [type]])
          }
          return arr;
        }, [])
      }
      return false;
    },
    generateWhereQuery(){
      const headers = this.valuedHeaders.filter(header => header.queryable);
      const whereValues = headers.reduce((arr, header) => {
        let {key, value} = header.queryable;
        if(value === null || value === '') return arr;
        if(header.queryable.type === 'text') arr.push({key: key, condition: 'ilike',value: `%${value.replace(/\s| /g, '%')}%`});
        if(header.queryable.type === 'boolean' && value !== null) arr.push({key: key, value: value});
        return arr;
      }, [])
      const whereInValues = headers.reduce((arr, header) => {
        let {key, value} = header.queryable;
        if(value === null || value === '' || (Array.isArray(value) && value.length === 0)) return arr;
        if(header.queryable.type === 'multi-select' && !header.queryable.relation){
          arr.push({key: key, value: value.reduce((valueArr, v) => {
              valueArr.push(v.uuid ? v.uuid : v[key])
              return valueArr
            }, [])})
        }
        return arr;
      }, [])

      let whereHasValues = [];
      const tests = headers.find(header => header.queryable && header.queryable.relation === "sampleTests");
      const flags = headers.find(header => header.queryable && header.queryable.relation === "sampleFlags");
      if(flags){
        whereHasValues = flags.queryable.value.reduce( (arr, item) =>{
          arr.push({
            relation: 'sampleFlags',
            where: [{key: 'sample_flag_type_uuid', value: item.uuid ? item.uuid : item}]
          })
          return arr;
        },[])
      }
      if(tests){
        whereHasValues = [...whereHasValues, ...tests.queryable.value.reduce( (arr, item) =>{
          arr.push({
            relation: 'sampleTests',
            where: [{key: 'sample_test_type_uuid', value: item.uuid ? item.uuid : item}]
          })
          return arr;
        },[])]
      }
      let query = {};
      if(whereValues.length > 0) query.where = whereValues;
      if(whereInValues.length > 0) query.where_in = whereInValues;
      if(whereHasValues && whereHasValues.length > 0) query.where_has = whereHasValues
      console.log(query, 'query');
      // return {};
      return query;
    }
  }
}
</script>

<style scoped>

</style>
